import {Box, Stack, Typography} from "@mui/material";
import bgImage from "../../../assets/images/simple_shiny.svg";


export const Benefits = () => {

  return (
    <Stack direction={"column"} gap={1} alignItems={"center"} sx={{bgcolor: "primary.light", p: {xs: 4, md: 10}, position: "relative" }}>
      <Stack maxWidth={"sm"} direction={"column"} gap={1} alignItems={"center"} sx={{zIndex: 2}}>
        <Typography fontWeight={600} color={"#fefefe"} align={"center"} fontSize={{xs: "1.2em", md: "1.6em"}}>Boost Efficiency & Happiness—Instantly</Typography>
        <Typography fontWeight={300} color={"#fefefe"} align={"center"} fontStyle={"italic"} fontSize={{xs: "1em", md: "1.1em" }}>
          Cut costs by 50-70% while boosting customer satisfaction — AI that saves money, keeps customers happy, and lets agents focus on what matters.
        </Typography>
      </Stack>

      <Box sx={{position: "absolute", inset: 0, borderRadius: "inherit"}}>
        <img src={bgImage} width={"100%"} height={"100%"} style={{objectFit: "cover", borderRadius: "inherit"}} />
      </Box>
    </Stack>
  )
}